export default __webpack_public_path__ + "static/media/inventory-banner.859f3479.webp";